module.exports = __webpack_public_path__ + "09_mustache_brown.caa91aa8.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer3/09_mustache_brown.png
// module id = V0rB
// module chunks = 0